export class LastShipmentContractModel {
    
    companyNameB?: string;
    companyAddressB?: string;
    companyPhoneB?: string;
    faxNumberB: string;
    taxCodeB?: string;
    accountNumber?: string;
    representB?: string;
    representRoleB?: string;
}